import { useTranslation } from 'react-i18next';
import { Badge, TableCell } from '../../../../2-component';
import { formatMoneyValueCentsWithDecimals, formatDecimalNumber, formatPercentValue } from '../../../../../util';
import { useLocalization } from '../../../../../util/useLocalization';
import { TradeStates } from '../tradeOrders';

export const TradeOrderCell = ({
  trade, isTrades, type, isFirst,
}: { trade: any, type: string, isFirst?: boolean, isTrades?: boolean }) => {
  const { t } = useTranslation(['components', 'shared', 'accountTypes']);
  const { localizedDateTime, localizedDate } = useLocalization();

  const account = isTrades ? trade?.account : trade?.subAccount?.account;
  const stateColor = trade.state === TradeStates.RECONCILED ? 'positive' : [TradeStates.FAILED, TradeStates.CANCELED].includes(trade.state) ? 'negative' : 'neutral';
  const expectedQuantity = isTrades ? trade?.expectedQuantity : trade?.trade?.expectedQuantity;

  switch (type) {
    case 'account':
      return <TableCell isFirst={isFirst} dense> {t(`accountTypes:${account.type}`)}</TableCell>;
    case 'accountNumber':
      return <TableCell isFirst={isFirst} dense>{account.custodianAccountNumber}</TableCell>;
    case 'symbol':
      return <TableCell isFirst={isFirst} dense bold>{trade.financialProduct.ticker ?? '-'}</TableCell>;
    case 'type':
      return <TableCell isFirst={isFirst} dense>{t(`transaction.types.${trade.type}`)}</TableCell>;
    case 'currency':
      return <TableCell isFirst={isFirst} dense>{trade.currency ?? '-'}</TableCell>;
    case 'description':
      return <TableCell isFirst={isFirst} dense>{(isTrades ? trade.description : trade.trade.description) ?? '-'}</TableCell>;
    case 'failReason':
      return <TableCell isFirst={isFirst} dense>{trade.failReason ?? '-'}</TableCell>;
    case 'value':
      return <TableCell isFirst={isFirst} dense>{formatMoneyValueCentsWithDecimals(trade.actualTradePriceCents * trade.actualQuantity)}</TableCell>;
    case 'tradeValue':
      return <TableCell isFirst={isFirst} dense>{trade.moneyAllocatedCents ? formatMoneyValueCentsWithDecimals(trade.moneyAllocatedCents) : '-'}</TableCell>;
    case 'actualQuantity':
      return <TableCell isFirst={isFirst} dense number>{trade.actualQuantity ? formatDecimalNumber(trade.actualQuantity) : '-'}</TableCell>;
    case 'actualPrice':
      return <TableCell isFirst={isFirst} dense number>{trade.actualTradePriceCents ? formatMoneyValueCentsWithDecimals(trade.actualTradePriceCents) : '-'}</TableCell>;
    case 'expectedQuantity':
      return <TableCell isFirst={isFirst} dense number>{expectedQuantity ? formatDecimalNumber(expectedQuantity) : '-'}</TableCell>;
    case 'expectedPrice':
      return (
        <TableCell isFirst={isFirst} dense number>{formatMoneyValueCentsWithDecimals(isTrades ? trade?.expectedTradePriceCents : trade?.trade?.expectedTradePriceCents)}</TableCell>
      );
    case 'state':
      return <TableCell isFirst={isFirst} dense><Badge label={t(`transfer:states.${trade.state}`)} color={stateColor} /></TableCell>;
    case 'createdAt':
      return <TableCell isFirst={isFirst} dense >{localizedDateTime(trade.createdAt)}</TableCell>;
    case 'tradeDate':
      return <TableCell isFirst={isFirst} dense >{localizedDate(isTrades ? trade.tradeDate : trade.trade.tradeDate)}</TableCell>;
    case 'settlementDate':
      return <TableCell isFirst={isFirst} dense >{localizedDate(isTrades ? trade.settlementDate : trade.trade.settlementDate)}</TableCell>;
    case 'percentageFilled':
      return <TableCell isFirst={isFirst} dense >{formatPercentValue(trade.percentageFilled, 1)}</TableCell>;
    case 'reconciledAt':
      return <TableCell isFirst={isFirst} dense >{trade.reconciledAt ? localizedDateTime(trade.reconciledAt) : '-'}</TableCell>;
    default:
      return <TableCell isFirst={isFirst}>{type}</TableCell>;
  }
};
